import type { IconData } from '@stacksjs/iconify-core'

export const callHangUp: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"3\"><path stroke-linejoin=\"round\" d=\"M28.643 28.641a20 20 0 0 0 4.997-8.321c.203-.668-.005-1.385-.498-1.878l-3.077-3.077a4 4 0 0 1-.885-4.314l2.466-6.165A3 3 0 0 1 34.43 3H35c5.523 0 10 4.477 10 10v1.332q0 .008-.006.013a.02.02 0 0 0-.005.013c-.223 8.339-3.687 15.87-9.178 21.379M24.19 32a20 20 0 0 1-3.87 1.64c-.668.203-1.385-.005-1.878-.498l-3.077-3.077a4 4 0 0 0-4.314-.885l-6.165 2.466A3 3 0 0 0 3 34.43V35c0 5.523 4.477 10 10 10h.5a31.35 31.35 0 0 0 18-5.646\"/><path d=\"m9 9l36 36\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default callHangUp
